export default __webpack_public_path__ + "static/media/dot_non-ce-selected.36ad5137.svg";